import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { HelmetProvider } from 'react-helmet-async';
import { initApiInterceptor } from './utils/apiInterceptor';
import { sendMetricToAnalytics } from './lib/analytics/webVitals';

initApiInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <FavoritesProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </FavoritesProvider>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);

const endpoint =
  process.env.REACT_APP_WEB_VITALS_ENDPOINT ||
  process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT ||
  '';
const debugFlag = process.env.REACT_APP_WEB_VITALS_DEBUG === 'true';

const handleMetric = (metric) => {
  sendMetricToAnalytics(metric, { endpoint, debug: debugFlag });
};

if (process.env.NODE_ENV === 'production') {
  reportWebVitals(handleMetric);
} else {
  reportWebVitals((metric) => {
    console.info('[web-vitals-dev]', metric);
    handleMetric(metric);
  });
}
